import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './i18n'; // Initialize i18n before App renders
import App from './App';

// ── Sentry Initialization (before React renders) ───────────────────────────
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.VITE_ENVIRONMENT || 'production',
    release: 'ifrs17-frontend@0.1.0',

    // Performance monitoring: 10% of transactions
    tracesSampleRate: 0.1,

    // Session replay for errors only (captures 30s before the error)
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],

    // Scrub PII: remove auth tokens from breadcrumbs
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === 'xhr' || breadcrumb.category === 'fetch') {
        if (breadcrumb.data?.headers) {
          delete breadcrumb.data.headers.Authorization;
        }
      }
      return breadcrumb;
    },
  });
  console.log('[Sentry] Initialized with DSN:', SENTRY_DSN.slice(0, 20) + '...');
} else {
  console.log('[Sentry] Disabled — no VITE_SENTRY_DSN set');
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
